import { Box, Popper, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import CloseButton from "../button/CloseButton";
import LoadEnvFactorButton from "../button/LoadEnvFactorButton";
import ResizableTextBox from "../input/ResizableTextBox";

const LoadEnvfactorMenu = ({ anchorRef, visible, onClose, onLoad, onUpload }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const [envFactors, setEnvFactors] = useState([
    {
      type: "Components for Windows and Curtain Walls",
      category: "Doors",
      sub_category: "Aluminium",
      description: "Aluminium Exterior Door With Light Cut-Out",
      factor: 1,
      quantity: 0,
      uncertainty: 1,
    },
    {
      type: "Building Service Engineering",
      category: "Heating",
      sub_category: "Heat distribution and dissipation",
      description: "Mineral Wool Insulation Panel",
      factor: 1,
      quantity: 0,
      uncertainty: 1,
    },
  ]);
  const [isValidJson, setIsValidJson] = useState(true);
  const [displayedEnvFactors, setDisplayedEnvFactors] = useState("");
  useEffect(() => {
    setDisplayedEnvFactors(JSON.stringify(envFactors, null, 2));
  }, [envFactors]);
  const handleChange = (e) => {
    try {
      JSON.parse(e.target.value);
      setIsValidJson(true);
    } catch (error) {
      setIsValidJson(false);
    }
    setDisplayedEnvFactors(e.target.value);
  };
  const handleBlur = (e) => {
    try {
      const parsed = JSON.parse(e.target.value);
      setEnvFactors(parsed);
      setIsValidJson(true);
    } catch (error) {
      setDisplayedEnvFactors(e.target.value);
      setIsValidJson(false);
    }
  };
  return (
    <Popper elevation={1} anchorEl={anchorRef.current} placement="bottom-end" open={visible} style={{ zIndex: 1300 }}>
      <Box
        sx={{
          backgroundColor: isDark ? "#1e1e1e" : "white",
          color: isDark ? "white" : "black",
          paddingBottom: 1,
          border: 1,
          borderColor: isDark ? "#333" : "lightgrey",
          borderRadius: 4,
          minWidth: 600,
          boxShadow: isDark ? "0px 4px 20px rgba(0,0,0,0.5)" : "0px 4px 10px rgba(0,0,0,0.1)",
        }}>
        <Box sx={{ display: "flex", justifyContent: "right" }}>
          <CloseButton onClick={() => onClose()} />
        </Box>
        <ResizableTextBox onChange={handleChange} onBlur={handleBlur} value={displayedEnvFactors} maxHeight={1000} />
        <LoadEnvFactorButton onClick={() => onLoad(envFactors)} disabled={!isValidJson} />
        <LoadEnvFactorButton onClick={() => onUpload(envFactors)} disabled={!isValidJson} />
      </Box>
    </Popper>
  );
};
export default LoadEnvfactorMenu;
